import type { Client } from '../../../models/client';

export const sentiment_status = (c: Client) => {
  if (c.risk_history == null || c.status == null || c.status === 'inactive' || c.risk_history[0]?.sentiment == null)
    return undefined;
  if (c.risk_history[0].sentiment >= 0.3) return 'Positive';
  if (c.risk_history[0].sentiment <= -0.3) return 'Negative';
  return 'Neutral';
};
